import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaKey, FaShieldAlt } from "react-icons/fa";
import { baseurl } from "../Baseurl";
import axios from "axios";
import Swal from "sweetalert2";

export default function SecuritySetting() {
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);

  const orgId = localStorage.getItem("organization_id");
  const adminId = localStorage.getItem("adminID");

  // UI toggles
  const [showPasswordSettings, setShowPasswordSettings] = useState(false);
  const [show2FASettings, setShow2FASettings] = useState(false);

  // Password + Email form
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newEmail, setNewEmail] = useState("");

  // 2FA form
  const [twoFAEnabled, setTwoFAEnabled] = useState(false);
  const [phone, setPhone] = useState("");

  // Fetch security settings on mount
  useEffect(() => {
    if (!adminId) navigate("/");

    const savedTheme = localStorage.getItem("darkMode") === "true";
    setDarkMode(savedTheme);
    document.body.classList.toggle("dark", savedTheme);

    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${baseurl}getSecuritySettings`, {
          params: { userId: adminId},
        });
        const data = res.data.data;
        setNewEmail(data.email || "");
        setTwoFAEnabled(data.two_fa_enabled || false);
        setPhone(data.phone || "");
      } catch (err) {
        console.error("❌ Failed to fetch settings:", err);
      }
    };

    fetchSettings();
  }, [navigate, adminId]);

  // Save password/email changes
  const updatePasswordLogin = async () => {
    if (newPassword !== confirmPassword) {
      Swal.fire("Error", "Passwords do not match!", "error");
      return;
    }

    try {
      await axios.post(`${baseurl}updatePasswordLogin`, {
        userId : adminId,
        orgId,
        newPassword,
        newEmail,
      });

      Swal.fire({
        icon: "success",
        title: "Updated",
        text: "Password/Email updated successfully",
        timer: 2000,
        showConfirmButton: false,
      });

      setNewPassword("");
      setConfirmPassword("");
      setNewEmail("");
    } catch (err) {
      console.error("❌ Failed to update password/email:", err);
      Swal.fire("Error", "Failed to update password/email", "error");
    }
  };

  // Save 2FA changes
  const update2FA = async () => {
    try {
      await axios.post(`${baseurl}updateTwoFA`, {
        userId : adminId,
        orgId,
        enabled: twoFAEnabled,
        phone,
      });

      Swal.fire({
        icon: "success",
        title: "Updated",
        text: "Two-factor authentication updated successfully",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error("❌ Failed to update 2FA:", err);
      Swal.fire("Error", "Failed to update 2FA", "error");
    }
  };

  return (
    <>
      <div className="settings-header">
        <h3>Security Settings</h3>
      </div>

      <div className="settings-menu">
        {/* Password & Login */}
        <div
          className="settings-menu-item"
          onClick={() => setShowPasswordSettings(!showPasswordSettings)}
          style={{ cursor: "pointer" }}
        >
          <div className="menu-icon">
            <FaKey />
          </div>
          <div className="menu-label">Password & Login</div>
          <div className="menu-arrow">{showPasswordSettings ? "▼" : "›"}</div>
        </div>

        {showPasswordSettings && (
          <div className="settings-subsection">
            <label>New Email:</label>
            <input
              type="email"
              className="form-control"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              placeholder="Enter new email"
            />

            <label style={{ marginTop: "10px" }}>New Password:</label>
            <input
              type="password"
              className="form-control"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
            />

            <label style={{ marginTop: "10px" }}>Confirm Password:</label>
            <input
              type="password"
              className="form-control"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
            />

            <button
              className="btn btn-primary mt-3"
              onClick={updatePasswordLogin}
            >
              Save Changes
            </button>
          </div>
        )}

        {/* 2FA */}
        <div
          className="settings-menu-item"
          onClick={() => setShow2FASettings(!show2FASettings)}
          style={{ cursor: "pointer" }}
        >
          <div className="menu-icon">
            <FaShieldAlt />
          </div>
          <div className="menu-label">2FA (Two Factor Authentication)</div>
          <div className="menu-arrow">{show2FASettings ? "▼" : "›"}</div>
        </div>

        {show2FASettings && (
          <div className="settings-subsection">
            <label>
              <input
                type="checkbox"
                checked={twoFAEnabled}
                onChange={(e) => setTwoFAEnabled(e.target.checked)}
              />{" "}
              Enable 2FA
            </label>

            {twoFAEnabled && (
              <>
                <label style={{ marginTop: "10px" }}>Mobile Number:</label>
                <input
                  type="text"
                  className="form-control"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="Enter mobile number"
                />
              </>
            )}

            <button className="btn btn-primary mt-3" onClick={update2FA}>
              Save 2FA Settings
            </button>
          </div>
        )}
      </div>
    </>
  );
}
